<template>
  <page :title="pageTitle" backTo="/marketing/banners" size="is-desktop">
    <div slot="page-header-right">
      <button class="button is-danger is-outlined mr-2" @click="destroy">
        <span>Delete</span>
      </button>

      <button
        v-if="form"
        class="button is-primary"
        :class="{ 'is-loading': form.processing }"
        @click="handleSubmit"
      >
        <span>Update</span>
      </button>
    </div>

    <form v-if="form" @submit.prevent="handleSubmit">
      <div class="columns">
        <div class="column is-5">
          <div class="box">
            <b-field label="Slider Name">
              <b-select v-model="form.slider" expanded>
                <option :value="label.id" v-for="(label, key) in sliders.data" :key="key">
                  {{
                    label.name
                  }}
                </option>
              </b-select>
            </b-field>

            <b-field :label="$tc('banner._name')+' '+$tc('name')">
              <b-input v-model="form.name"></b-input>
            </b-field>

            <b-field label="Banner Media Type">
              <b-select v-model="form.content_type" expanded>
                <option value="image" selected>Image</option>
                <option value="video">Video</option>
              </b-select>
            </b-field>
          </div>

          <div class="box">
            <b-field>
              <b-checkbox v-model="form.is_active">Is Active?</b-checkbox>
            </b-field>

            <b-field label="Start Date">
              <datetimepicker v-model="form.starts_at"></datetimepicker>
            </b-field>

            <b-field label="End Date">
              <datetimepicker v-model="form.ends_at"></datetimepicker>
            </b-field>
          </div>
        </div>

        <div class="column is-7">
          <div class="box">
            <b-field label="Link" message="Deep or outgoing link.">
              <b-input v-model="form.link"></b-input>
            </b-field>
          </div>

          <div class="box" v-if="form.content_type === 'video'">
            <div class="level">
              <div class="level-left">
                <p class="title is-5">Mobile</p>
              </div>

              <div class="level-right">
                <a @click="$refs.imageSm.pick()">
                  <span v-if="form.content_type === 'image'">Update Image</span>
                  <span v-if="form.content_type === 'video'">Update Video</span>
                </a>
              </div>
            </div>

            <media-image
              ref="imageSm"
              model-type="Modules.Marketing.Banner"
              :content-type="form.content_type"
              :model-id="banner.id"
              collection="images.sm"
              :default-image-src="banner.media.sm"
              style="min-height: 100px;"
            ></media-image>
          </div>

          <div class="box" v-else>
            <div class="level">
              <div class="level-left">
                <p class="title is-5">Mobile</p>
              </div>

            </div>
              <upload-banner-image
                :src="banner.media.sm"
                :banner-id="banner.id"
                size="sm"
                style="min-height: 100px;"
              ></upload-banner-image>
          </div>

          <div class="box" v-if="form.content_type === 'video'">
            <div class="level">
              <div class="level-left">
                <p class="title is-5">Tablet</p>
              </div>

              <div class="level-right">
                <a @click="$refs.imageMd.pick()">
                  <span v-if="form.content_type === 'image'">Update Image</span>
                  <span v-if="form.content_type === 'video'">Update Video</span>
                </a>
              </div>
            </div>

            <media-image
              ref="imageMd"
              model-type="Modules.Marketing.Banner"
              :content-type="form.content_type"
              :model-id="banner.id"
              collection="images.md"
              :default-image-src="banner.media.md"
              style="min-height: 100px;"
            ></media-image>
          </div>

          <div class="box" v-else>
            <div class="level">
              <div class="level-left">
                <p class="title is-5">Tablet</p>
              </div>
            </div>

              <upload-banner-image
                :src="banner.media.md"
                :banner-id="banner.id"
                size="md"
                style="min-height: 100px;"
              ></upload-banner-image>
          </div>
        </div>
      </div>
    </form>
  </page>
</template>

<script>
import MediaImage from "../../../components/media-image/Index";
import UploadBannerImage from "@/modules/admin/pages/marketing/UploadBannerImage";

export default {
  components: {
    MediaImage,
    UploadBannerImage
  },

  data() {
    return {
      sliders: new window.RemoteCollection(
        "/admin/api/marketing/sliders"
      ).load(),
      banner: null,
      form: null
    };
  },

  created() {
    this.load();
  },

  computed: {
    pageTitle() {
      return "Banner - #" + this.$route.params.id;
    }
  },

  methods: {
    uri() {
      return "/admin/api/marketing/banners/" + this.$route.params.id;
    },

    load() {
      this.$http.get(this.uri()).then(response => {
        this.banner = response.data.data;
        this.initialize();
      });
    },

    initialize() {
      this.form = new window.Form({
        name: this.banner.name,
        link: this.banner.deep_link,
        content_type: this.banner.content_type,
        is_active: this.banner.is_active,
        starts_at: this.banner.starts_at,
        ends_at: this.banner.ends_at,
        slider: this.banner.slider ? this.banner.slider.id : null
      });
    },

    handleSubmit() {
      this.form.put(this.uri()).then(() => {
        this.$buefy.toast.open("Banner updated");

        this.$router.push("/marketing/banners");
      });
    },

    destroy() {
      this.$buefy.dialog.confirm({
        title: "Deleting banner?",
        message: "This action is permenant.",
        cancelText: "Cancel",
        confirmText: "Delete banner",
        type: "is-danger",
        hasIcon: true,
        onConfirm: () => {
          this.$http
            .delete(`/admin/api/marketing/banners/${this.banner.id}`)
            .then(() => {
              this.$router.push("/marketing/banners");

              this.$buefy.toast.open({
                type: "is-success",
                message: "Banner deleted."
              });
            });
        }
      });
    }
  }
};
</script>
